export default [
    {
        path: "/epigenetics",
        component: () => import("@/view/epigenetics/EpigeneticsLayout.vue"),
        meta: {
            requiresAuth: true,
        },
        redirect: { name: "epigenetics-overview" },
        children: [
            {
                path: "overview",
                name: "epigenetics-overview",
                component: () => import("@/view/epigenetics/OverviewTab.vue"),
            },
            {
                path: "epi",
                name: "epigenetics-epi",
                component: () => import("@/view/epigenetics/EpiGeneticsTab.vue"),
            },
            {
                path: "risk-factor",
                name: "epigenetics-risk",
                component: () => import("@/view/epigenetics/RiskFactorTab.vue"),
            },
            {
                path: "reports",
                name: "epigenetics-reports",
                component: () => import("@/view/epigenetics/Overview.vue"),
            },
        ],
    },
];
